<template>
  <v-container fluid>
    <v-tabs v-model="activeTab" centered>
      <v-tab>General</v-tab>
      <v-tab>Quality Settings</v-tab>
      <v-tab>User Gear</v-tab>
      <v-tab>Server</v-tab>
      <v-tab-item><GeneralStatistics/></v-tab-item>
      <v-tab-item><UserSettingsStatistics/></v-tab-item>
      <v-tab-item><UserGearStatistics/></v-tab-item>
      <v-tab-item><ServerStatistics/></v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>

import GeneralStatistics from "@/components/statistics/GeneralStatistics";
import UserSettingsStatistics from "@/components/statistics/UserSettingsStatistics";
import UserGearStatistics from "@/components/statistics/UserGearStatistics";
import ServerStatistics from "@/components/statistics/ServerStatistics";

export default {
  name: 'Statistics',
  components: {
    GeneralStatistics,
    UserSettingsStatistics,
    UserGearStatistics,
    ServerStatistics
  },
  data: () => ({
    activeTab: 0
  })
};
</script>

<style scoped>

</style>